// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-container {
    padding-top: 20px;
    padding-bottom: 40px;
}
  
.card {
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}
  
.card-header {
    background-color: #f8f9fa;
    font-weight: 500;
}
  
@media (max-width: 768px) {
    .profile-container {
        padding-top: 10px;
    }
    
    .card {
      margin-bottom: 20px;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/Account/Profile.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;MACE,mBAAmB;IACrB;AACJ","sourcesContent":[".profile-container {\n    padding-top: 20px;\n    padding-bottom: 40px;\n}\n  \n.card {\n    box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n  \n.card-header {\n    background-color: #f8f9fa;\n    font-weight: 500;\n}\n  \n@media (max-width: 768px) {\n    .profile-container {\n        padding-top: 10px;\n    }\n    \n    .card {\n      margin-bottom: 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
